import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'form-input',
    templateUrl: 'input.component.html',
    styleUrls: ['input.component.scss']
})
export class InputComponent {

    @Input() label = '';
    @Input() placeholder = '';
    @Input() maxLength: number | undefined;
    @Input() required = false;
    @Input() disabled = false;
    @Input() type = "text";
    @Input() warningText = '';

    @Output()
    valueChange = new EventEmitter<string>();

    _value;

    constructor() {
    }

    @Input()
    get value(): string {
        if (this._value) {
            return this._value;
        }
        return "";
    }

    set value(val: string) {
        this._value = val;
        this.valueChange.emit(this._value);
    }

}
